'use client'

import { Base } from '@/ui/components'
import React, { forwardRef, memo, useImperativeHandle, useRef } from 'react'
import { BaseProps } from '../types'

interface Props extends Omit<BaseProps, 'as'> {
  as?: 'p' | 'div' | 'span' | 'blockquote' | 'cite' | 'q'
  children?: React.ReactNode
  ref?: React.RefObject<HTMLElement>
}

const Text = forwardRef<HTMLElement, Props>(
  ({ className, as = 'p', children, ...props }, ref) => {
    //refs
    const comp = useRef<any>(null)
    useImperativeHandle(ref, () => comp.current as HTMLElement)

    if (!children) {
      return null
    }

    return (
      <Base as={as} ref={comp} className={className} {...props}>
        {children}
      </Base>
    )
  }
)
Text.displayName = 'Text'

export default memo(Text)
